import { ValidateField } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/shared.ts';
import {
  InputEditor,
  FormFieldControl,
} from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/type.ts';
import { Input_Base as BaseComponent } from '@services/MarppleShopStudio/shared/component/atom/Input/core/Input_Base.ts';

export abstract class Input_Base<T extends Partial<InputEditor>>
  extends BaseComponent<T>
  implements FormFieldControl
{
  public abstract override getName(): ValidateField;
}
